import React from 'react';
import axios from 'axios';
import logo from './DubberMSTeamsSmall_New.png';
import { NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ChatUserList } from './ChatUserList';
import { Ring } from './Ring';

const SETTING_NAMES = {
  CHAT_RECORDING_APP_ID: 'chatRecordingAppId',
  HAS_INTEGRATION: 'hasIntegration',
  RECORD_TEAMS_USER: 'recordTeamsUser',
  RECORD_DELEGATE_USER: 'recordDelegateUser',
  RECORD_TEAMS_USERS: 'recordTeamsUsers',
  DELEGATE_USERS: 'delegateUsers',
};

const INTEGRATION_CONFIG = {
  teams: {
    header: 'Teams',
    recordingKey: 'teamsRecordingEnabled',
    existingUsersKey: 'existingTeamsRecordedUsers',
    settingName: SETTING_NAMES.RECORD_TEAMS_USERS,
    recordingFlag: SETTING_NAMES.RECORD_TEAMS_USER,
  },
  delegate: {
    header: 'Integration',
    recordingKey: 'delegateRecordingEnabled',
    existingUsersKey: 'existingDelegateRecordedUsers',
    settingName: SETTING_NAMES.DELEGATE_USERS,
    recordingFlag: SETTING_NAMES.RECORD_DELEGATE_USER,
  },
};

class ChatSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      userErrorMessage: '',
      loading: false,
      existingRecordedUsers: [],
      existingTeamsRecordedUsers: [],
      existingDelegateRecordedUsers: [],
      hasIntegration: null,
      recordTeamsUser: false,
      recordDelegateUser: false,
      showRecordingOptions: null,
    };

    this.getUserList = this.getUserList.bind(this);
    this.onUserSearchTextChanged = this.onUserSearchTextChanged.bind(this);
    this.loadNextPageOfUsersToState = this.loadNextPageOfUsersToState.bind(this);
    this.saveChatSettings = this.saveChatSettings.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onUserSelectionChanged = this.onUserSelectionChanged.bind(this);
    this.onExternalIntegrationChanged = this.onExternalIntegrationChanged.bind(this);
    this.onRecordingOptionChanged = this.onRecordingOptionChanged.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });

    axios
      .get(
        this.props.configurationUrl +
          '/' +
          this.props.tenantId +
          '?slug=' +
          this.props.slug +
          '&region=' +
          this.props.portalCode,
        {
          headers: {
            Authorization: 'Jwt ' + this.props.accessToken,
            'Cache-Control': 'no-store',
          },
        }
      )
      .then(taskResponse => {
        let chatRecordingAppId = taskResponse.data.settings.find(
          m => m.name === SETTING_NAMES.CHAT_RECORDING_APP_ID
        );
        let integration = taskResponse.data.settings.find(
          m => m.name === SETTING_NAMES.HAS_INTEGRATION
        );
        let recordTeamsUser = taskResponse.data.settings.find(
          m => m.name === SETTING_NAMES.RECORD_TEAMS_USER
        );
        let recordDelegateUser = taskResponse.data.settings.find(
          m => m.name === SETTING_NAMES.RECORD_DELEGATE_USER
        );
        let delegateUsers = taskResponse.data.settings.find(
          m => m.name === SETTING_NAMES.DELEGATE_USERS
        );
        let recordTeamsUsers = taskResponse.data.settings.find(
          m => m.name === SETTING_NAMES.RECORD_TEAMS_USERS
        );

        if (!chatRecordingAppId || chatRecordingAppId.length === 0) {
          this.saveChatSettings(SETTING_NAMES.CHAT_RECORDING_APP_ID, this.props.chatRecordingAppId);
        }

        if (integration != null) {
          const hasIntegration = integration.value === 'true';
          const showRecordingOptions = hasIntegration;

          this.setState({
            hasIntegration: hasIntegration,
            showRecordingOptions: showRecordingOptions,
          });
        }

        if (recordTeamsUser != null) {
          this.setState({
            recordTeamsUser: recordTeamsUser.value === 'true',
          });
        } else {
          this.setState({
            recordTeamsUser: integration?.value === 'false',
          });
        }

        if (recordDelegateUser != null) {
          this.setState({
            recordDelegateUser: recordDelegateUser.value === 'true',
          });
        }

        const delegateUsersList = delegateUsers?.value?.split(',') || [];
        const teamsUsersList = recordTeamsUsers?.value?.split(',') || [];
        const existingRecordedUsers = [...delegateUsersList, ...teamsUsersList];

        this.setState(
          {
            existingDelegateRecordedUsers: delegateUsersList,
            existingTeamsRecordedUsers: teamsUsersList,
            existingRecordedUsers: existingRecordedUsers,
          },
          () => this.getUserList()
        );
      });
  }

  getUserList(searchTerm = null, skipToken = null) {
    let config = {};
    let body = {
      portal: this.props.portalCode,
      tenantId: this.props.tenantId,
      chatRecordingAppId: this.props.chatRecordingAppId,
      searchTerm: searchTerm === undefined ? null : searchTerm,
      skipToken: skipToken,
    };
    this.setState({
      userErrorMessage: '',
      loading: true,
    });
    axios
      .post(this.props.aadUsersUrl, body, config)
      .then(taskResponse => {
        this.setState({ loading: false });
        this.setState({
          skipToken: taskResponse.data.skipToken,
        });

        let response = taskResponse.data.users.map(user => {
          const userWithRecording = { ...user };
          Object.values(INTEGRATION_CONFIG).forEach(config => {
            userWithRecording[config.recordingKey] = this.state[config.existingUsersKey].includes(
              user.id
            );
          });
          return userWithRecording;
        });

        if (skipToken === null) {
          this.setState({
            userList: response,
          });
        } else {
          let newUserList = this.state.userList.concat(response);
          this.setState({
            userList: newUserList,
          });
        }

        if (taskResponse.data === null || taskResponse.data.length === 0) {
          this.setState({ userErrorMessage: 'No users found' });
        }
      })
      .catch(error => {
        this.setState({ loading: false });
        console.log(error);
        this.setState({ userErrorMessage: 'Could not retrieve users' });
      });
  }

  loadNextPageOfUsersToState(event) {
    event.preventDefault();
    this.getUserList(null, this.state.skipToken);
  }

  async onUserSearchTextChanged(event) {
    event.preventDefault();

    this.setState({ userList: [] }, this.getUserList(event.target.value));
  }

  async onSave(integrationType) {
    this.setState({ loading: true });

    const { recordingKey, settingName } = INTEGRATION_CONFIG[integrationType];

    const usersCombined = this.state.userList
      .filter(user => user[recordingKey] === true)
      .map(user => user.id)
      .join();

    await this.saveChatSettings(settingName, usersCombined);

    // Update the recording flag when a user is enabled for recording ?
    //
    // if (this.state[recordingFlag] === false) {
    //   this.setState({ [recordingFlag]: true }, async () => {
    //     await this.saveChatSettings(recordingFlag, "true");
    //   });
    // }

    this.setState({ loading: false });
  }

  async saveChatSettings(settingName, settingValue) {
    let body = {
      settingValue: settingValue,
      slug: this.props.slug,
      region: this.props.portalCode,
    };
    await axios
      .put(
        this.props.configurationUrl + '/' + this.props.tenantId + '/setting/' + settingName,
        body,
        {
          headers: {
            Authorization: 'Jwt ' + this.props.accessToken,
          },
        }
      )
      .then(_response => {})
      .catch(error => {
        console.log(error);
      });
  }

  onUserSelectionChanged(userId, isChecked, integrationType) {
    const { recordingKey } = INTEGRATION_CONFIG[integrationType];
    let userList = this.state.userList;
    userList.forEach(user => {
      if (user.id === userId) {
        user[recordingKey] = isChecked;
      }
    });
    this.setState({ userList: userList }, async () => {
      await this.onSave(integrationType);
    });
  }

  onExternalIntegrationChanged(hasIntegration) {
    const stateUpdate = {
      hasIntegration: hasIntegration,
      showRecordingOptions: hasIntegration,
    };

    if (!hasIntegration) {
      stateUpdate.recordTeamsUser = true;
      stateUpdate.recordDelegateUser = false;
    }

    this.setState(stateUpdate, async () => {
      await this.saveChatSettings(SETTING_NAMES.HAS_INTEGRATION, hasIntegration.toString());
      if (!hasIntegration) {
        await this.saveChatSettings(SETTING_NAMES.RECORD_TEAMS_USER, 'true');
        await this.saveChatSettings(SETTING_NAMES.RECORD_DELEGATE_USER, 'false');
      }
    });
  }

  onRecordingOptionChanged(option, isChecked) {
    if (option === 'teams') {
      this.setState({ recordTeamsUser: isChecked }, async () => {
        await this.saveChatSettings(SETTING_NAMES.RECORD_TEAMS_USER, isChecked.toString());
      });
    } else if (option === 'integration') {
      this.setState({ recordDelegateUser: isChecked }, async () => {
        await this.saveChatSettings(SETTING_NAMES.RECORD_DELEGATE_USER, isChecked.toString());
      });
    }
  }

  renderIntegrationQuestion() {
    return (
      <div className="integration-question">
        <h4>Do you have any external integration?</h4>
        <div className="integration-options">
          <div className="radio-option">
            <input
              type="radio"
              id="hasIntegrationYes"
              name="hasIntegration"
              value="yes"
              checked={this.state.hasIntegration === true}
              onChange={() => this.onExternalIntegrationChanged(true)}
            />
            <label htmlFor="hasIntegrationYes">Yes</label>
          </div>
          <div className="radio-option">
            <input
              type="radio"
              id="hasIntegrationNo"
              name="hasIntegration"
              value="no"
              checked={this.state.hasIntegration === false}
              onChange={() => this.onExternalIntegrationChanged(false)}
            />
            <label htmlFor="hasIntegrationNo">No</label>
          </div>
        </div>
      </div>
    );
  }

  renderRecordingOptions() {
    return (
      <div className="recording-options">
        <h4>What do you want to record?</h4>
        <div className="recording-checkboxes">
          <div className="checkbox-item">
            <input
              type="checkbox"
              id="teamsChat"
              checked={this.state.recordTeamsUser}
              onChange={e => this.onRecordingOptionChanged('teams', e.target.checked)}
            />
            <label htmlFor="teamsChat">Teams chat</label>
          </div>
          <div className="checkbox-item">
            <input
              type="checkbox"
              id="integrationChat"
              checked={this.state.recordDelegateUser}
              onChange={e => this.onRecordingOptionChanged('integration', e.target.checked)}
            />
            <label htmlFor="integrationChat">Integration chat</label>
          </div>
        </div>
        <div className="info-messages">
          <p className="info-text">
            * Enabled users will not be recorded until recording type selected here.
          </p>
        </div>
      </div>
    );
  }

  renderUserList(integration) {
    return (
      <ChatUserList
        integration={integration}
        userList={this.state.userList}
        hasExternalIntegration={this.state.hasIntegration}
        userErrorMessage={this.state.userErrorMessage}
        onUserSelectionChanged={this.onUserSelectionChanged}
        onUserSearchTextChanged={this.onUserSearchTextChanged}
        skipToken={this.state.skipToken}
        onLoadMore={this.loadNextPageOfUsersToState}
      />
    );
  }

  render() {
    return (
      <div id="main" className="ui text container transition">
        <Ring loading={this.state.loading} />

        <div id="chatsettings" className="wizard-step">
          <div className="no-top-margin">
            <div className="ui center aligned container head">
              <div className="stepheader">
                <div className="step">Chat Recording Settings</div>
                <img src={logo} alt="Dubber MS Teams" className="small-logo" />
                <div className="step-back">
                  <NavLink tag={Link} to="/chatconsent">
                    &lt; Back
                  </NavLink>
                </div>
                <div className="ui aligned container start">
                  <div className="step-header">
                    <h3>Configure Teams Chat Recording</h3>

                    {/* External Integration Question */}
                    {this.renderIntegrationQuestion()}

                    {/* Show delegate users configuration */}
                    {this.state.hasIntegration && this.renderUserList('delegate')}

                    {/* Recording Options - Show only if external integration is Yes */}
                    {this.state.showRecordingOptions && this.renderRecordingOptions()}

                    {/* Show teams user configuration */}
                    {this.state.hasIntegration != null && this.renderUserList('teams')}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { ChatSettings, SETTING_NAMES };
